module.exports = __webpack_public_path__ + "static/media/buy_donate_map.44703afc.svg";